import React, { Component } from "react";
import RightChat from "./RightChat";
import LeftChat from "./LeftChat";
import "./ChatList.css";
import ColorHelper from "../../helper/ColorHelper";

export default class ChatList extends Component {
  constructor(props) {
    super(props);
    this.scrollChat = React.createRef();
  }
  componentDidMount() {
    this.scrollToBottom();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  scrollToBottom = () => {
    this.scrollChat.current.scrollTop = this.scrollChat.current.scrollHeight;
  };

  render() {
    let { msgList, agentName, agentId } = this.props;
    agentName = agentName.split(" ")[0];
    const { chat: chatLabels } = window["labels"];
    return (
      <div className="chatlist-container" ref={this.scrollChat}>
        <div
          className={agentId !== -1 ? "chatlist-start" : "chatlist-noavilable"}
        >
          {agentId !== -1 ? (
            <div className="chatlist-header">
              <div className="chatlist-header-icon">
                <i className="gcl-icon agent-filter" />
              </div>
              <div>
                <span>{chatLabels.title} {agentName}{" "}</span>
              </div>
            </div>
          ) : (
            <>
              <div
                className="chatlist-clock"
                style={ColorHelper.getInstance().getChatClockColorStyle()}
              ></div>
              <span>{chatLabels.busyAgent}</span>
            </>
          )}
        </div>
        {msgList.map((element, index) =>
          element.position === "left" ? (
            <LeftChat
              key={index}
              msg={element.msg}
              hour={element.hour}
              agentName={agentName}
              messageType={element.messageType}
            />
          ) : (
            <RightChat
              key={index}
              msg={element.msg}
              hour={element.hour}
              messageType={element.messageType}
            />
          )
        )}
        <div className="chatlist-end"></div>
      </div>
    );
  }
}
